import { idtype, fullPageImage } from "querypieces";

export default `
... on pageBuilder_fullPagePhotoMatrix_BlockType {
	${idtype}
	id
	themePicker
	fullPagePhotoMatrix {
	  ... on fullPagePhoto_Entry {
		id
		altText
		photoBorderSwitch
		${fullPageImage}
	  }
	  ... on header_Entry {
		id
		header
	  }
	  ... on subheader_Entry {
		id
		subheader
	  }
	  ... on introBody_Entry {
		id
		introBody
	  }
	  ... on body_Entry {
		id
		body
	  }
	  ... on cta_Entry {
		id
		cta {
			text
			type
			url
			element {
			  uri
			}
		}
	  }
	}
  }

`